"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const HeaderActions = _ref => {
  let {
    isLoggedIn,
    LoggedInActions,
    LoggedOutActions,
    headerType
  } = _ref;
  if (isLoggedIn) {
    return /*#__PURE__*/_react.default.createElement(LoggedInActions, {
      headerType: headerType
    });
  }
  return /*#__PURE__*/_react.default.createElement(LoggedOutActions, null);
};
HeaderActions.propTypes = {
  LoggedInActions: _propTypes.default.elementType,
  LoggedOutActions: _propTypes.default.elementType
};
var _default = exports.default = HeaderActions;